import 'react-toastify/dist/ReactToastify.css';

import { toast } from 'react-toastify';
import Markdown from 'react-markdown'
import styled from "@emotion/styled";

const StyledMarkdown = styled(Markdown)`
  white-space: pre-wrap !important;
`;

export function toastmsg(message, position, autoClose) {
    toast.dismiss();
    const xyz=toast(<StyledMarkdown>{message}</StyledMarkdown>, {
      position: position, //toast.POSITION.TOP_CENTER
      type: toast.TYPE.DEFAULT,
      autoClose: 5000, // 5sec
      className: "blue",
      pauseOnHover: true,
      newestOnTop: true
    });
    return xyz;
  }

export function getExtension(file)
{
    if (!file) return ""; // 🤷🏼‍♂️
    let uploadedFileExtension = file.substr((file.lastIndexOf('.') + 1))
    return uploadedFileExtension;
}
export const timeInterval = 3000
